/** Constantes du créateur de poster */
export const POSTER_WIDTH = 400;
export const POSTER_HEIGHT = 600;
export const POSTER_PAD = 20;

export const TEMPLATES = [
  {
    id: "amber",
    nameKey: "posterTemplateClassic",
    bg: "linear-gradient(135deg, #d97706 0%, #b45309 50%, #92400e 100%)",
    card: "rgba(255,255,255,0.12)",
    accent: "rgba(251,191,36,0.25)",
  },
  {
    id: "slate",
    nameKey: "posterTemplateElegant",
    bg: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
    card: "rgba(255,255,255,0.08)",
    accent: "rgba(251,191,36,0.2)",
  },
  {
    id: "emerald",
    nameKey: "posterTemplateFresh",
    bg: "linear-gradient(135deg, #047857 0%, #065f46 50%, #064e3b 100%)",
    card: "rgba(255,255,255,0.1)",
    accent: "rgba(167,243,208,0.2)",
  },
  {
    id: "rose",
    nameKey: "posterTemplateWarm",
    bg: "linear-gradient(135deg, #be123c 0%, #9f1239 50%, #881337 100%)",
    card: "rgba(255,255,255,0.1)",
    accent: "rgba(254,226,226,0.2)",
  },
];
